import {LocationSet, RemoteLocationSet} from './locationSets.types';
import {DateTime} from 'luxon';

function toClientLocationSet(remoteLocationSet: RemoteLocationSet): LocationSet {
  return {
    ...remoteLocationSet,
    ...(remoteLocationSet.lastPopulationDate && {
      lastPopulationDate: DateTime.fromISO(remoteLocationSet.lastPopulationDate),
    }),
  };
}

export {toClientLocationSet};
